import React from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'deltoid/core/Blocks/BootstrapContainers';
import { H, Caption } from 'deltoid/core/Blocks/Typography';
import PayuIcons from 'deltoid/core/PayUIcons';
import { dialogActions } from '@store/ducks';

const CONTENT = [
  'Upon accepting and sharing the Aadhaar number, You (the Aadhaar holder), hereby irrevocably:', 
  'a. Place a request to Payu Payments Private Limited and Karza Technologies Private Limited (“Karza”) to access Your Aadhaar Information from UIDAI to fetch and verify information regarding Aadhaar Number, Aadhaar XML, Aadhaar details, demographic information, identity information, Aadhaar registered mobile number and any other information as may be admissible as per applicable law, (collectively referred to as “Aadhaar Information”)',
  'b. Explicitly authorise Payu Payments Private Limited and Karza to fetch Your Aadhaar Information from UIDAI to make it available to Payu Payments Private Limited and/or any third party, as may be required for availing (“Purpose”).',
  'c. Acknowledge that you are aware of alternate forms of providing consent and have voluntarily chosen to furnish your Aadhaar Information.',
  'd. Agree to take all the necessary actions required for the purpose of authenticating and verifying Your Aadhaar Information.',
  'e. Give a valid, binding, irrevocable and explicit authorisation and consent as may be required under applicable laws, rules, regulations and guidelines for availing the Aadhaar API services of Karza including, but not limited to the transmission and storage of Your Aadhaar Information by Payu Payments Private Limited and Karza.',  
  'f. Understand and agree that the Consent has been submitted by You voluntarily and without any coercion from Payu Payments Private Limited or Karza or any other party.',
  'g. Fully understand and accept sole and complete responsibility for any issues, legal suits, damages, losses, penalties, fines or liabilities (“Losses”) arising out of Your sharing of Aadhaar Information and authorising Payu Payments Private Limited or Karza for fetching Your Aadhar Information and that You will fully hold harmless Payu Payments Private Limited and Karza, its representatives, employees and directors for any Losses arising out of such request and actions.',
  'h. Karza does not store or retain any Aadhaar Information including the Aadhaar number belonging to You after it has processed Your request.',
  'i. Payu Payments Private Limited will not be storing Aadhaar number but shall be storing your information such as address etc. as per applicable laws.”',
]

const Tnc = ({close}) => (
  <>
    <Row className='p-3 border-bottom justify-content-between' noGutters>
      <H level={6}>Terms and Condition</H>
      <span onClick={close} className='align-self-center cursor-pointer'>
        <PayuIcons type='cancel' size="16px"/>
      </span>
    </Row>
    <Row className='p-3' noGutters>
      <Col md={12}>
        <H level={5} variant='bold' className='mb-4'>Aadhar Terms and Conditions</H>
        {CONTENT.map((text, index) => (
          <Caption key={`aadhar-tnc-${index}`} className='mb-2 text-dark'>{text}</Caption>
        ))}
      </Col>
    </Row>
  </>
);

export default connect(
  null,
  (dispatch) => ({
    close: () => dispatch(dialogActions.close()),
  })
)(Tnc);
